import { makeStyles } from '@mui/styles';

export default makeStyles({
  root: {
    maxHeight: '270px',
    overflow: 'auto',
  },
});
